import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { useSportContext } from '@sorare/core/src/contexts/sport';
import { FILTERS } from '@sorare/core/src/lib/filters';

import { useRemoveMarketFilterChipEvent } from '#src/hooks/events/useRemoveMarketFilterChipEvent.ts';
import { useFormatFilterWidgetValue } from '#src/hooks/search/useFormatFilterWidgetValue/index.tsx';
import { FilterChip } from '#src/search/ActiveFilters/FilterChip/index.tsx';
import type { RefinementItem } from '#src/search/ActiveFilters/types.ts';

const ChipTitle = styled.span.attrs(props => ({ lang: props.lang }))`
  &:after {
    content: ': ';
  }
  &:lang(fr-FR):after {
    content: ' : ';
  }
`;

export const RangeActiveFilter = ({ item }: { item: RefinementItem }) => {
  const { formatMessage, locale } = useIntl();
  const trackRemoveMarketFilterChip = useRemoveMarketFilterChipEvent();
  const { sport } = useSportContext();
  const { formatFilterWidgetValue } = useFormatFilterWidgetValue();

  const title = useMemo(
    () =>
      Object.values(FILTERS).find(
        ({ attribute }) => attribute === item.attribute
      )?.title,
    [item.attribute]
  );

  const [label] = formatFilterWidgetValue(item);

  const onClick = useCallback(() => {
    item.refinements.forEach(refinement => {
      item.refine(refinement);
    });
    if (sport && typeof label === 'string') {
      trackRemoveMarketFilterChip(item.attribute, label, sport);
    }
  }, [item, label, trackRemoveMarketFilterChip, sport]);

  if (!title) {
    return null;
  }

  return (
    <FilterChip
      label={
        <>
          <ChipTitle lang={locale}>{formatMessage(title)}</ChipTitle>
          <span>{label}</span>
        </>
      }
      onClose={onClick}
    />
  );
};
